// Models
import { PeerStats } from 'src/app/models/peer-stats/peer-stats';

// Services
import { SignalingTransportService } from '../signaling-transport/signaling-transport.service';
import { DataChannelService } from '../data-channel/data-channel.service';
import { IssueRemediationService } from 'src/app/services/issue-remediation/issue-remediation.service';
import { ParticipantsListService } from '../participants-list/participants-list.service';
import { SignalingService } from '../signaling/signaling.service';
import { VirtualBackgroundService } from '../virtual-background/virtual-background.service';

export class StatsDisplay {
  constructor(
    private transport: SignalingTransportService,
    private background: VirtualBackgroundService,
    private dataChannel: DataChannelService,
    private issueRemediation: IssueRemediationService,
    private participants: ParticipantsListService,
    private signaling: SignalingService,
  ) {}

  getHostData(report: PeerStats): string {
    let text = '';
    text += 'GetStats Loop: ' + report.stVolatility?.toFixed(2) + '% / ' + report.dtVolatility?.toFixed(2) + '%';
    text += '<br />Bandwidth: ' + report.incomingBitrate?.toFixed(2) + 'kbps';
    text += ' / ' + report.outgoingBitrate?.toFixed(2) + 'kbps';
    text += '<br />Nb Participants: ' + this.participants.visibleParticipantNb;
    if (this.background.isActive) {
      text += '<br />Virtual background: ' + this.background.resolution;
    }
    return text;
  }

  getData(id: string, report: PeerStats): string {
    if (id) {
      let text = '';
      if (report.participantsStats[id]) {
        text += id;
        text += '<br />Bandwidth: ' + report.participantsStats[id].incomingBitrate?.toFixed(2) + 'kbps';
        text += ' / ' + report.participantsStats[id].outgoingBitrate?.toFixed(2) + 'kbps';
        text += '<br />RTT: ' + report.participantsStats[id].rtt + 'ms';
        text += '<br />AV Delay: ' + report.participantsStats[id].avDelay + 'ms';
        text += '<br />Audio Jitter: ' + (report.participantsStats[id].audio.jitterIn * 1000).toFixed(1) + 'ms';
        text += ' / ' + (report.participantsStats[id].audio.jitterOut * 1000).toFixed(1) + 'ms';
        text += '<br />Video Jitter: ' + (report.participantsStats[id].video.jitterIn * 1000).toFixed(1) + 'ms';
        text += ' / ' + (report.participantsStats[id].video.jitterOut * 1000).toFixed(1) + 'ms';
        text += '<br />FPS: ' + report.participantsStats[id].video.fpsIn.toFixed(0);
        text += ' / ' + report.participantsStats[id].video.fpsOut.toFixed(0);
        text += '<br />Resolution: ' + report.participantsStats[id].video.frameWidthIn + 'x';
        text += report.participantsStats[id].video.frameHeightIn;
        text += ' / ' + report.participantsStats[id].video.frameWidthOut + 'x';
        text += report.participantsStats[id].video.frameHeightOut;
        text += '<br />Encoder Time: ' + (report.participantsStats[id].video.decodeTimePerFrame * 1000).toFixed(1) + 'ms';
        text += ' / ' + (report.participantsStats[id].video.encodeTimePerFrame * 1000).toFixed(1) + 'ms';
        text += '<br />Profile: ' + this.issueRemediation.participantRemediations.remote[id]?.id;
        text += ' / ' + this.issueRemediation.participantRemediations.local[id]?.id;
        text += '<br />Data Channel Messages: ' + this.dataChannel.counts[id] + ' (' + (Date.now() - this.dataChannel.lasts[id]) + 'ms)';
        text += '<br />Signaling Messages: ' + this.signaling.counts[id] + ' (' + this.transport.connectionState + ')';
        text += '<br />Data Channel State: ' + this.participants.participants[id]?.dataChannel?.remoteReadyState;
        text += ' / ' + this.participants.participants[id]?.dataChannel?.readyState;
        text += '<br />Connection State: ' + this.participants.participants[id]?.pc?.remoteConnectionState;
        text += ' / ' + this.participants.participants[id]?.pc?.connectionState;
        text += '<br />Ice Connection State: ' + this.participants.participants[id]?.pc?.remoteIceConnectionState;
        text += ' / ' + this.participants.participants[id]?.pc?.iceConnectionState;
        text += '<br />Reconnect State: ' + (this.participants.participants[id]?.attemptingReconnect ? 'Connecting' : 'Connected');
      }
      return text;
    } else {
      return null;
    }
  }
}
